import './LinkTree.css'
function LinkTree () {
    return (
        <a href="https://linktr.ee/rememberingayurveda" target="_blank" 
  rel="noopener noreferrer" className="link-tree">Link Tree</a>
    )
}

export default LinkTree;